<template>
  <div id="DetalleDeDocumento_div" class="w-100 px-0 py-0">
    <div id="TituloDetalleDeDocumento_div">
      <h5 class="label-black" style="margin-bottom: 0px;">SOLICITUDES POR VERIFICAR</h5>
      <h6 class="label-black" style="margin-top: 0px;">Gestión de Solicitudes de documentos</h6>
    </div>
    <Solicitudes :SolicitudApi=this.Ruta></Solicitudes>
    <!-- <br/>
    <h6 style="margin-top: 0px;">Estadistico</h6>
    <div style="display: flex">
      <div div class="col-3 padding">
        <div class="area">
            <div class="form-group " >
              <label>Fecha para Estadistico</label>
              <input type="date" class="form-control"  v-model="Fecha"/>
            </div>
           <button type="button" class="btn btn-dark" >Aceptar</button>
          
        </div>
      </div>
      <div div class="col-9 padding">
        <div class="area">

        </div>
      </div> -->
    <!-- </div> -->
  </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import Solicitud from '@/components/ArchivoJudicial/Comun/SolicitudesVerifica.vue'

export default {
    components: {
        Solicitudes: Solicitud
    },
     data(){
        return{
            Ruta : "",
            Fecha: moment().format('YYYY-MM-DD')
        }
    },
    mounted(){

    },
    created(){
        this.Ruta = api.ArchivoJudicial.TodosSolicitudesPorVerificar;
    }
}

</script>
<style scoped>
  #cuerpoModalDetalles {
    overflow-y: auto;
    max-height: 500px;
  }
  input[type="text"]:read-only {
    background: #504f54;
  }
  input[type="text"]:read-only:focus {
      color: #fff;
    }
  textarea[type="text"]:read-only {
    background: #504f54;
  }
  textarea[type="text"]:read-only:focus {
      color: #fff;
  }
  .label-black {
      color: black;
  }
</style>



// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Solicitudes/SolicitudesPorVerificar.vue